import { render, staticRenderFns } from "./XBtnWithAuth.vue?vue&type=template&id=6fc30030&"
import script from "./XBtnWithAuth.vue?vue&type=script&lang=js&"
export * from "./XBtnWithAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports